
export const SORTCODE_PART1_START = 0;
export const SORTCODE_PART1_END = 2;
export const SORTCODE_PART2_START = 2;
export const SORTCODE_PART2_END = 4;
export const SORTCODE_PART3_START = 4;
export const SORTCODE_PART3_END = 6;
export const GTM_FORM_NAME = 'finance';

export const ACCOUNT_NAME_MAX_LENGTH = 50;
export const ACCOUNT_NUMBER_MAX_LENGTH = 9;
export const SORT_CODE_LENGTH = 2;
export const ACCOUNT_NUMBER_MIN_LENGTH = 7;
export const YEARS_THAT_ALLOWS_ZERO_MONTHS_IN_BANK_ACCOUNT_TIME = 6;

export const ACCOUNT_NAME_REQUIRED_ERROR_MESSAGE = 'Please provide an account name';
export const ACCOUNT_NUMBER_REQUIRED_ERROR_MESSAGE = 'Please provide your account number';
export const ACCOUNT_NUMBER_INVALID_ERROR_MESSAGE = 'Please provide a valid Account number';
export const SORTCODE_REQUIRED_ERROR_MESSAGE = 'Please provide your sort code';
export const SORTCODE_MIN_LENGTH_ERROR_MESSAGE = 'Each part of your sort code should be two characters';
export const FINANCE_FORM_CONFIRMATION_REQUIRED_ERROR_MESSAGE = 'Please confirm that the statement above is true';
export const ACCOUNT_NUMBER_DOES_NOT_MACH_TO_SORT_CODE_ERROR_MESSAGE = 'Your account number and sort code do not match';